<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="回复状态："  label-for="key">
              <Select v-model="filter.reply_status" @on-change="select">
                <Option :value="0">全部</Option>
                <Option :value="1">未回复</Option>
                <Option :value="2">已回复</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="reply(row)" :disabled="row.reply_status === 2">回复</a>
          <Divider type="vertical" />
          <a @click="del(row.user_information_id)">删除</a>
        </template>
      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>

    <Modal
      v-model="replyShow"
      title="资询回复">
      <Form ref="replyForm" :model="replyForm" :label-width="100" label-position="right" @submit.native.prevent
            style="padding:20px">
        <Row>
          <Col>
            <FormItem label="回复内容：" label-for="key">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入回复内容"
                     v-model="replyForm.reply"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="replyCancel">取消</Button>
        <Button type="primary" @click="replyOk">提交</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import {userInformationListApi, userInformationDelApi, userInformationSaveApi} from '@/api/user/userInformation'

export default {
  name: 'userInformationList',
  inject: ['reload'],
  data () {
    return {
      replyShow: false,
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        reply_status: 0,
        ctime: [],
      },
      replyForm: {
        user_information_id: 0,
        reply: ''
      },
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '用户昵称',
          key: 'user_nickname',
          minWidth: 150
        },
        {
          title: '咨询内容',
          key: 'content',
          minWidth: 300
        },
        {
          title: '回复内容',
          key: 'reply',
          minWidth: 300
        },
        {
          title: '回复状态',
          key: 'reply_status_msg',
          minWidth: 120
        },
        {
          title: '回复时间',
          key: 'reply_time',
          minWidth: 150
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 150
        }
      ]
    }
  },
  created () {
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      userInformationListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 清空搜索
    searchClear () {
      this.filter.search = ''
      this.filter.page = 1
      this.loadTableData()
    },
    // 下拉选择
    select (status) {
      this.filter.page = 1
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },

    // 回复打开
    reply(row) {
      this.replyForm.user_information_id = row.user_information_id
      this.replyForm.reply = ''
      this.replyShow = true
    },
    // 回复提交
    replyOk() {
      if (!this.replyForm.reply) {
        this.$Message.error('请输入回复内容')
        return
      }
      userInformationSaveApi(this.replyForm).then(res => {
        if (res.code === 200) {
          this.$Message.success('成功')
          this.replyShow = false
          this.reload()
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 回复取消
    replyCancel() {
      this.replyForm.user_information_id = 0
      this.replyForm.reply = ''
      this.replyShow = false
    },

    // 删除
    del (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否确认删除？',
        onOk: () => {
          userInformationDelApi(id).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.reload()
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

  }
}
</script>
